/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "../../global.css";
import api from "../../api";
import InputMask from "react-input-mask";
import FieldErrorValidation from "../../components/FieldErrorValidation";
import { NOTIFICATION_TYPE, openNotification } from "../../utils/notification";
// import PlaceField from "../../components/forms/PlaceField";
import { getStates } from "../../services/getLocation";
import AddressAutocomplete from "../../components/AddressAutocomplete";
import Loading from "../../components/Loading";
import { propertyTypeSections } from "../../components/PropertyComposition/constants";


export default function StepOne({
  setStep,
  step,
  setEndereco,
  endereco,
  setNumero,
  numero,
  setComplemento,
  complemento,
  setTipo,
  tipoSelected,
  setBairro,
  block,
  setBlock,
  setCurrentPlace,
  currentPlace,
}) {
  const [tipoArray, setTipoArray] = useState([]);
  const [tipe, setTipe] = useState("");
  const [pristine, setPristine] = useState({
    address: true,
    type: true,
  });

  function handleNext() {
    setPristine({
      address: false,
      type: false,
    });
    validatePlace(currentPlace);
    if (!checkErrorStyle('address').isValid)
      return;
    if (!checkErrorStyle('type').isValid) {
      openNotification("Informe o tipo de imóvel!", NOTIFICATION_TYPE.warning);
      return;
    }
    setStep(2);
  }

  const handleLoadTypes = async () => {

    const { data } = await api.get("/propertyType/v2");
    const activePropertyTypes = data.filter(
      x => propertyTypeSections.some(y => y.propertyType == x._id && !y.disabled)
    )

    let tips = new Array();
    activePropertyTypes.map((item) => {
      tips.push({ value: item._id, name: item.name });
      if (item._id == tipoSelected) {
        setTipe(item.name);
      }
    });
    setTipoArray(tips);
  };

  const RIO_DE_JANEIRO = "Rio de Janeiro";
  const [loading, setLoading] = useState(false);
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(RIO_DE_JANEIRO);
  const handleStates = async () => {
    setLoading(true);
    try {
      const { data } = await getStates();
      let states = new Array();
      data.map((item) => {
        states.push({ value: item.name, name: item.uf });
      });
      setStateOptions(states);
    }
    catch (error) {
      console.error("Error fetching states:", error);
      openNotification("Erro ao carregar estados!", NOTIFICATION_TYPE.error);
    }
    finally {
      setLoading(false);
    }
  };

  const [cityOptions, setCityOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const handleCities = async (val) => {
    if (!val) return;
    setLoading(true);
    try {
      const { data } = await api.get(`/city?stateName=${val}`);
      let cities = new Array();
      data.citys.map((item) => {
        cities.push({ value: item._id, name: item.name });
      });
      setCityOptions(cities);
      if (!selectedCity && selectedState === RIO_DE_JANEIRO) {
        setSelectedCity(cities.find(x => x.name === RIO_DE_JANEIRO).value);
      }
      return cities;
    }
    catch (error) {
      console.error("Error fetching cities:", error);
      openNotification("Erro ao carregar cidades!", NOTIFICATION_TYPE.error);
    }
    finally {
      setLoading(false);
    }
  };

  // { state: { value: "Rio de Janeiro", name: "RJ" }, city: { value: 145, name: "Rio de Janeiro" } }
  const [selectedCityAndState, setSelectedCityAndState] = useState();
  useEffect(() => {
    if (selectedState && selectedCity) {
      var currentState = stateOptions.find(x => x.value === selectedState);
      var currentCity = cityOptions.find(x => x.value === selectedCity);
      setSelectedCityAndState({ state: currentState, city: currentCity });
    } else {
      setSelectedCityAndState();
    }
  }, [selectedState, selectedCity, stateOptions, cityOptions]);

  const checkErrorStyle = (fieldName) => {

    // if (fieldName === 'address' && !pristine.address && (!endereco || !numero))
    if (fieldName === 'address') {

      if (!(endereco === currentPlace?.address
        && numero === currentPlace?.addressNumber
        && currentPlace?.cityName === selectedCityAndState?.city?.name
        && currentPlace?.stateName === selectedCityAndState?.state?.name))
        return {
          pristine: pristine.address,
          isValid: false,
          errorMessage: "Os dados de endereço não correspondem, por favor, selecione novamente!",
        };
      return {
        pristine: pristine.address,
        isValid: !!(endereco && numero),
        errorMessage: !endereco ? "Selecione um endereço válido!" : "Informe o número corretamente e selecione!",
      };
    }
    // if (fieldName === 'type' && !pristine.type && !tipoSelected)
    if (fieldName === 'type' && !pristine.type)
      return {
        pristine: pristine.type,
        isValid: tipoSelected > 0,
      };

    if (fieldName === 'uf' && !pristine.uf && !selectedState)
      return {
        pristine: pristine.uf,
        isValid: selectedState !== "Selecione",
        errorMessage: "Selecione um estado!",
      };

    if (fieldName === 'city' && !pristine.city && !selectedCity)
      return {
        pristine: pristine.city,
        isValid: selectedCity !== "Selecione",
        errorMessage: "Selecione uma cidade!",
      };

    if (fieldName === 'number' && !pristine.number && !numero)
      return {
        pristine: pristine.number,
        isValid: numero !== "",
        errorMessage: "Informe o número!",
      };

    return {};

  };

  useEffect(() => {
    setPristine({
      address: !endereco,
      type: !tipoSelected
    });
    handleStates();
    if (selectedState) {
      handleCities(selectedState);
    }
  }, [selectedState]);

  useEffect(() => {

    let dirtyAddress = !pristine.address;
    let dirtyType = !pristine.type;

    if (endereco)
      dirtyAddress = true;

    if (tipoSelected)
      dirtyType = true;

    setPristine({
      address: !dirtyAddress,
      type: !dirtyType,
    });

  }, [endereco, tipoSelected]);

  useEffect(() => {
    handleLoadTypes();
  }, []);

  const verify = (value) => {
    if (!(value === endereco)) {
      setBlock(true);
    }
  };

  const validatePlace = (place) => {
    if (!place.address) {
      openNotification("Endereço inválido!", NOTIFICATION_TYPE.warning);
      return false;
    }

    if (!place.addressNumber) {
      openNotification("Número não informado!", NOTIFICATION_TYPE.warning);
      return false;
    }

    return true;

  };

  // const [numero, setNumero] = useState("");

  const handleAddressSelect = async (addressData) => {
    if (!addressData) {
      setCurrentPlace({});
      setEndereco("");
      return;
    }

    setLoading(true);
    try {
      let cities = cityOptions;
      console.log('Endereço selecionado:', addressData);
      const stateItem = stateOptions.find(x => x.name === addressData.stateName);
      if (stateItem && stateItem.name !== selectedState) {
        cities = await handleCities(stateItem.value);
      }
      let cityItem = cities.find(x => x.name === addressData.cityName);
      if (cityItem) {
        setSelectedState(stateItem.value);
        setSelectedCity(cityItem.value);
        setNumero(addressData.addressNumber);
        setEndereco(addressData.address);
        setSelectedCityAndState({ state: stateItem, city: cityItem });
        setCurrentPlace(addressData);
      }
      else {
        setCurrentPlace({});
      }
    } catch (error) {
      console.error("Erro ao selecionar endereço", error);
      openNotification("Erro ao selecionar endereço!", NOTIFICATION_TYPE.error);
    } finally {
      setLoading(false);
    }

  };


  return (
    <>
      {loading && <Loading />}
      <div className="step">
        <div className="container-input-box">
          <FieldErrorValidation {...checkErrorStyle('uf')} className="input-box input-box-small">
            <small>Estado*</small>
            <select
              value={selectedState}
              name="Estado"
              onChange={async (value) => {
                const val = (value.target.value === "Selecione") ? '' : value.target.value;
                setSelectedState(val);
                await handleCities(val);
              }}
            >
              <option id="optiTeste">Selecione</option>
              {stateOptions.map((items) => (
                <option key={items.value.toString()} value={items.value}>{`${items.name}`}</option>
              ))}
            </select>
          </FieldErrorValidation>
          <FieldErrorValidation {...checkErrorStyle('city')} className="input-box input-box-large">
            <small>Cidade*</small>
            <select
              value={selectedCity}
              name="Cidade"
              onChange={(value) => {
                const val = (value.target.value === "Selecione") ? '' : value.target.value;
                setSelectedCity(val);
              }}
            >
              <option id="optiTeste">Selecione</option>
              {cityOptions.map((items) => (
                <option key={items.value.toString()} value={items.value}>{items.name}</option>
              ))}
            </select>
          </FieldErrorValidation>
        </div>
        <div className="container-input-box">
          <div className="input-box input-box-small">
            <small>Número</small>
            <InputMask
              value={numero || ""}
              onChange={({ target }) => setNumero(target.value)}
            />
          </div>
          <FieldErrorValidation {...checkErrorStyle('address')} className="input-box input-box-large">
            <small>Endereço</small>
            <AddressAutocomplete
              uf={selectedCityAndState?.state?.name}
              city={selectedCityAndState?.city?.name}
              number={numero}
              onAddressSelect={handleAddressSelect}
              currentPlace={currentPlace}
            />
            {/* {currentPlace && (
              <pre>{JSON.stringify(currentPlace, null, 2)}</pre>
            )} */}

          </FieldErrorValidation>
        </div>
      </div>
      <div className="step">

        <div className="container-input-box">
          <FieldErrorValidation {...checkErrorStyle('type')} className="input-box">
            <small>Tipo de imóvel*</small>
            <select
              value={tipoSelected}
              name="Tipo"
              onChange={(value) => {
                const val = (value.target.value === "Selecione") ? '' : value.target.value;
                setTipo(val);
              }}
            >
              <option id="optiTeste">Selecione</option>
              {tipoArray.map((items) => (
                <option key={items.value.toString()} value={items.value}>{items.name}</option>
              ))}
            </select>
          </FieldErrorValidation>
          <div className="input-box">
            <small>Complemento (Bl 1 | Sl 5 | Lj A | Apto 345)</small>
            <InputMask
              value={complemento}
              onChange={(text) => setComplemento(text.target.value)}
            />
          </div>

        </div>
        <div className="container-next">
          <button onClick={handleNext}>Avançar</button>
        </div>
      </div>
    </>
  );
}
